export default function IconDownload() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_29_3758)">
        <path
          d="M22.4 13.3334C23.2833 13.3334 24 14.05 24 14.9334V19.7334C24 22.0896 22.0895 24 19.7333 24H4.26666C1.91042 24 0 22.0896 0 19.7334V14.9334C0 14.05 0.716666 13.3334 1.6 13.3334C2.48333 13.3334 3.19999 14.05 3.19999 14.9334V19.7334C3.19999 20.3219 3.67709 20.8 4.26666 20.8H19.7333C20.3229 20.8 20.8 20.3219 20.8 19.7334V14.9334C20.8 14.05 21.5166 13.3334 22.4 13.3334Z"
          fill="currentColor"
        />
        <path
          d="M10.8689 0.460545C11.4991 -0.139454 12.5033 -0.167588 13.1314 0.460545L18.4647 5.79387C19.0898 6.41888 19.0898 7.43136 18.4647 8.05637C17.8397 8.68138 16.8273 8.68138 16.2022 8.05637L13.6002 5.4543V16.5252C13.6002 17.4085 12.8835 18.1252 12.0002 18.1252C11.1168 18.1252 10.4002 17.4085 10.4002 16.5252V5.4543L7.79809 8.05637C7.16788 8.65741 6.16372 8.6845 5.53559 8.05637C4.90746 7.42824 4.93559 6.42512 5.53559 5.79387L10.8689 0.460545Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_29_3758">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
